module.exports = __webpack_public_path__ + "img/slide4-en.0fc639f0.png";